import classnames from "classnames";
import React, { useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import EditFieldSettingTab from "./EditFieldSettingTab";

export const EditFieldSetting = () => {
    const location = useLocation();
    const [activeTab, setactiveTab] = useState("1");
    const [headerValue, setHeaderValue] = useState("Edit");

    const toggle = (tab: any) => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    };

    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingTop: 10, paddingBottom: 20, display: "flex", flexDirection: "row" }}>
                            <Link style={{ color: "black" }}
                                to="/organisations"
                                className="nav_link"
                            >
                                <h5>Organizations</h5>
                            </Link>
                            <i className="bi bi-chevron-right"></i>
                            <Link style={{ color: "black", marginLeft: 10 }}
                                to={{
                                    pathname: '/field-setting',
                                    state: location.state.organisations
                                }}
                                className="nav_link"
                            >
                                <h5>{location.state.organisations.name}</h5>
                            </Link>
                            <i className="bi bi-chevron-right"></i>
                            <h5 style={{ marginRight: 13, marginLeft: 13 }}>{location.state.fields.name}</h5>
                            <i className="bi bi-chevron-right"></i>
                            <h5 style={{ marginLeft: 13, opacity: 0.6 }}>{headerValue} Field</h5>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col xl={12}>
                        <Card style={{ border: 0 }}>
                            <CardBody >
                                <div className="row">
                                    <div className="col-2">
                                        <Nav tabs className="flex-column nav nav-pills">
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer", backgroundColor: activeTab === "2" ? "white" : "#6c757d", color: activeTab === "2" ? "black" : "white" }}
                                                    className={classnames({
                                                        active: activeTab === "1",
                                                    })}
                                                    onClick={() => {
                                                        toggle("1");
                                                    }}
                                                >
                                                    Edit Field
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer", backgroundColor: activeTab === "1" ? "white" : "#6c757d", color: activeTab === "1" ? "black" : "white" }}
                                                    className={classnames({
                                                        active: activeTab === "2",
                                                    })}
                                                    onClick={() => {
                                                        toggle("2");
                                                    }}
                                                >
                                                    Source Field
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                    <div className="col-10">
                                        <TabContent activeTab={activeTab} className="text-muted">
                                            <TabPane tabId="1">
                                                <Row>
                                                    <Col>
                                                        <EditFieldSettingTab />
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="2">
                                                <Row>
                                                    <Col>
                                                        <></>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
}

